import React from 'react';
import { IResortPageSnowInfo } from '@/api/resort/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { MiniSectionHeading, StatBlock } from './atoms';

export const LiftsTerrain = ({ fullResort }: { fullResort: IResortPageSnowInfo }) => {
  const { t } = useOTSTranslation('common');
  const hasLifts = !!fullResort.lifts?.total;
  const hasRuns = !!fullResort.runs?.total;
  const hasAcres = !!fullResort.terrain?.acres?.open;

  if (!hasLifts && !hasRuns) return null;

  return (
    <section>
      <MiniSectionHeading title={t('resort.skiReport.liftsTerrain')} />
      <div className="border-b border-border" />
      <div className="grid grid-cols-2 gap-y-5 py-5 sm:grid-cols-4">
        {hasLifts && (
          <StatBlock
            label={t('resort.skiReport.liftOpen')}
            value={`${fullResort.lifts!.open ?? 0} / ${fullResort.lifts!.total}`}
          />
        )}
        {hasRuns && (
          <StatBlock
            label={t('resort.skiReport.runsOpen')}
            value={`${fullResort.runs!.open ?? 0} / ${fullResort.runs!.total}`}
          />
        )}
        {hasAcres && (
          <StatBlock
            label={t('resort.skiReport.acresOpen')}
            value={fullResort.terrain!.acres!.open!}
          />
        )}
        {hasRuns && (
          <StatBlock
            label={t('resort.skiReport.percentOpen')}
            value={Math.round(((fullResort.runs!.open ?? 0) / fullResort.runs!.total) * 100)}
            unit="%"
          />
        )}
      </div>
      <div className="border-b border-border" />
    </section>
  );
};
